import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../configurationService';
import { PurchaseService } from '../purchase/purchase.service';
import { ObjectNames, MenuItems } from '../constants/constants';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent implements OnInit {

  index = 0;
  channelTypeId;
  configMenuPurchaseItems = [];
  allPurchaseTypes = [];
  purchaseTypeConfig;  
  
  purchaseTypeTemplateConfig: any;

  purchaseTemplateTypeId: any;
  purchaseTemplateConfig: any;
  allInventoryTypeTemplateJSON: any;
  allPurchaseTemplates = [];

  purchaseStatusTypeId: any;
  purchaseStatusConfig: any;
  purchaseStatusTemplateJSON: any;
  allPurchaseStatus = [];

  purchaseSubmoduleTypeId: any;
  purchaseSubmoduleConfig: any;
  purchaseSubmoduleJSON: any;
  allPurchaseSubmodule = [];

  sectionTypeId: any;

  constructor(private service: ConfigurationService,private purchaseConfigService: PurchaseService) { }

  ngOnInit(): void {
    this.getConfigurationTypes();
    this.configMenuPurchaseItems = [
      // {
      //   label: MenuItems.Category,
      //   icon: 'pi pi-plus',
      //   command: () => {
      //   }
      // },
      {
        label: MenuItems.Field,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddPurchaseField();
        }
      },
    ];
  }

  getConfigurationTypes() {
    this.purchaseConfigService.getAllTypes().subscribe(types => {
      this.purchaseTemplateTypeId = types.filter(type => type.name == ObjectNames.purchaseOrderConstants.Purchase_Template_TypeName)[0].id;
      this.purchaseStatusTypeId = types.filter(type => type.name == ObjectNames.purchaseOrderConstants.Purchase_Status_TypeName)[0].id;
      this.purchaseSubmoduleTypeId = types.filter(type => type.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_TypeName)[0].id;
      this.sectionTypeId = types.filter(type=> type.name==ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
      this.loadConfigurations('Purchase');
    })
  }

  loadConfigurations(moduleName) {
    this.service.getConfigurationByModuleName(moduleName).subscribe(configs => {
      // console.log(configs)
      this.purchaseTemplateConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Template_Object && s.typeId == this.purchaseTemplateTypeId)[0];
      this.allInventoryTypeTemplateJSON = (this.purchaseTemplateConfig?.configurationDetails && this.purchaseTemplateConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.purchaseTemplateConfig.configurationDetails[0].configJSONValue) : []);
      for (let type of this.allInventoryTypeTemplateJSON) {
        if (type.id !== 0) {
          this.allPurchaseTemplates.push(type);
        }
      }

      this.purchaseStatusConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Status_Object && s.typeId == 
      this.purchaseStatusTypeId)[0];
      this.purchaseStatusTemplateJSON = (this.purchaseStatusConfig?.configurationDetails[0]?.configJSONValue != "" ? JSON.parse(this.purchaseStatusConfig.configurationDetails[0].configJSONValue) : []);
      for (let status of this.purchaseStatusTemplateJSON) {
        if (status?.id !== 0) {
          this.allPurchaseStatus.push(status);
        }
      }

      this.purchaseSubmoduleConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_Object && s.typeId == 
      this.purchaseSubmoduleTypeId)[0];
      this.purchaseSubmoduleJSON = (this.purchaseSubmoduleConfig?.configurationDetails[0]?.configJSONValue != "" ? JSON.parse(this.purchaseSubmoduleConfig.configurationDetails[0].configJSONValue) : []);
      for (let status of this.purchaseSubmoduleJSON) {
        if (status?.id !== 0) {
          this.allPurchaseSubmodule.push(status);
        }
      }
    });
  }

  getIndex(event) {
    this.index = event.index;
  }
  getData(c) {
    this.index = c;
  }

  showAddPurchaseField() {
    this.purchaseConfigService.setPurchaseField(ObjectNames.BehaviorSubjectVariable);
    this.index = 2;
  }

}
